import { Link } from 'react-router-dom';

export default function ArticlePreview() {
  return (
    <section className="w-full bg-background-50 py-16 md:py-20">
      <div className="w-full px-6 md:px-10">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          <div className="w-full lg:w-2/5">
            <div className="rounded-2xl overflow-hidden aspect-[4/3]">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20home%20office%20with%20laptop%20showing%20spreadsheet%20interface%20on%20light%20wood%20desk%2C%20coffee%20cup%20and%20notebook%20nearby%2C%20natural%20morning%20light%20through%20sheer%20curtains%2C%20organized%20creative%20workspace%2C%20warm%20neutral%20interior%2C%20editorial%20quality&width=800&height=600&seq=v2-article-prev&orientation=landscape"
                alt="Mulebuy Spreadsheet complete guide preview"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <div className="w-full lg:w-3/5">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-label tracking-wider mb-4">
              In-Depth Guide
            </span>
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-5 leading-tight">
              What is Mulebuy Spreadsheet? A Complete Guide
            </h2>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-3">
              In the world of product sourcing and cross-border e-commerce, efficiency is everything. A <strong>mulebuy spreadsheet</strong> serves as the central nervous system for your sourcing operations &mdash; organizing supplier contacts, product specifications, pricing tiers, shipping options, and quality metrics all in one accessible format.
            </p>
            <p className="text-foreground-500 text-sm leading-relaxed mb-6">
              This comprehensive guide walks you through everything you need to know: from setting up your first mulebuy spreadsheet structure to advanced tips for optimizing your sourcing workflow. Whether you are a beginner just starting out or an experienced sourcer looking to streamline operations, this guide has actionable insights for every level.
            </p>
            <div className="flex flex-col sm:flex-row gap-3">
              <Link
                to="/what-is-mulebuy-spreadsheet"
                className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                Read Full Guide
                <i className="ri-arrow-right-line"></i>
              </Link>
              <Link
                to="/"
                className="inline-flex items-center gap-2 px-7 py-3 rounded-full border border-background-300 text-foreground-600 text-sm font-medium hover:border-foreground-400 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer"
              >
                Back to Mulebuy Spreadsheet
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}